var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagOfSuriname({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 118,
    viewBox: "0 0 177 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2764_6301)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 177,
    height: 118,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177 0H0V118H177V0Z",
    fill: "#377E3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177 23.5996H0V94.3996H177V23.5996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177 35.4004H0V82.6004H177V35.4004Z",
    fill: "#B40A2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4997 37.6533L102.371 80.3461L66.0547 53.9605H110.945L74.628 80.3461L88.4997 37.6533Z",
    fill: "#ECC81D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2764_6301"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 177,
    height: 118,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagOfSuriname);
export default __webpack_public_path__ + "static/media/Flag_of_Suriname.28781574e39310bac8794d043faa2aa3.svg";
export { ForwardRef as ReactComponent };